<template>
	<div style="width:1400px; height:810px;" v-on:keyup.esc="close()">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type_no_border mgr_10" style="padding-top:3px;">
					<label class="mgr_10"><input type="radio" value="S" v-model="invoice_type" /> Sale</label>
					<label class="mgr_10"><input type="radio" value="R" v-model="invoice_type" /> Return</label>
				</span>
				<em class="lt_text">Status</em>
				<span class="int_type_no_border mgr_10">
					<CodeSelect className="tbl_select" :codes="saleStatusCodes" :showDesc="false" v-model="status_code" @post-loading="postStatusLoading" />
				</span>

				<em class="lt_text">Sales Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="so_date_from"/> ~ <CustomDatePicker v-model="so_date_to"/></span>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>
			</div>
			<div class="left_option">
				<span class="int_type_no_border mgr_5">
					<!-- <input type="text" class="int_type ssm_int" v-model="ship_to_code" placeholder="Ship To" autocomplete="off" @click="selectPartner('ship')" /> -->
					<PartnerSelect v-model="ship_to_code" ph="Ship To" :showName="false" @set-partner="setShipTo" />
				</span>
				<span class="int_type_no_border mgr_5">
					<!-- <input type="text" class="int_type ssm_int" v-model="bill_to_code" placeholder="Bill To" autocomplete="off" @click="selectPartner('bill')" /> -->
					<PartnerSelect v-model="bill_to_code" ph="Bill To" :showName="false" @set-partner="setBillTo" />
				</span>

				<em class="lt_text">State</em>
				<span class="int_type_no_border mgr_10"> <CodeSelect :width="100" :codeWidth="120" :showDesc="false" :codes="states" v-model="state" /> </span>

				<span class="int_type sm_int">
					<input type="text" v-model="keyword" ref="spkeyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<div class="view_inner">
			<div class="fixed-table-container" style="height:670px;">
				<div class="table-wrapper">
					<table id="item_list" class="list_tbl">
						<thead>
							<tr>
								<th style="text-align:center;width:5%;"><div class="th-text">S/O No</div></th>
								<th style="text-align:center;width:8%;"><div class="th-text">S/O Date</div></th>
								<th style="text-align:center;width:5%;"><div class="th-text">Invoice No</div></th>
								<th style="text-align:center;width:10%;"><div class="th-text">Status</div></th>
								<th style="text-align:center;width:6%;"><div class="th-text ">Ship To</div></th>
								<th style="text-align:center;width:8%;"><div class="th-text">Ship To</div></th>
								<th style="text-align:center;width:6%;"><div class="th-text">Bill To</div></th>
								<th style="text-align:center;width:5%;"><div class="th-text">Payment</div></th>
								<th style="text-align:center;width:8%;"><div class="th-text">Delivery</div></th>
								<th style="text-align:center;width:8%;"><div class="th-text">Sales Group</div></th>
								<th style="text-align:center;width:5%;"><div class="th-text">Qty</div></th>
								<th style="text-align:center;width:5%;"><div class="th-text">Amount</div></th>
								<th style="text-align:center;width:8%;"><div class="th-text">To Accouting</div></th>
								<th style="text-align:center;"><div class="th-text">To Customer</div></th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="invoice in invoices" v-bind:key="invoice.invoice_no" @dblclick="selectRow(invoice)">
								<td>
									<font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">
										<a href="javascript:;" @click="selectSo(invoice)">{{ invoice.so_dn }}</a>
									</font>
								</td>
								<td>{{ invoice.so_date }}</td>
								<td>
									<a href="javascript:;" @click="selectInvoice(invoice)">{{ invoice.invoice_dn }}</a>
								</td>
								<td class="al_center">{{ invoice.status_code | saleStatusName }}</td>
								<td class="al_left">{{ invoice.ship_to_code }}</td>
								<td class="al_left truncate">{{ invoice.ship_to_name }}</td>
								<td class="al_left">{{ invoice.bill_to_code }}</td>
								<td class="al_left">{{ invoice.payment_term_code }}</td>
								<td class="al_left">{{ invoice.delivery_type_name }}</td>
								<td class="al_left">{{ invoice.sales_group_name }}</td>
								<td class="al_right">{{ invoice.total_quantity | commaSeparated }}</td>
								<td class="al_right">{{ invoice.total_amount | toCurrency }}</td>
								<td class="al_left">{{ invoice.remark }}</td>
								<td class="al_left">{{ invoice.description }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- <div>
					{{ selectedUserIds }}
				</div> -->
			</div>

			<br />

			<div class="view_bottom_bt">
				<a href="javascript:;" id="save" type="button" class="gray_bt" @click="close()">Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import '@/assets/css/table_box.css';
//import { apiSelectPartnerList } from '@/api/partner/index.js';
import { apiSoIndex, apiSelectInvoiceList } from '@/api/sales/invoice.js';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import { daysAgo, today } from '@/utils/date.js';

export default {
	data: function() {
		return {
			invoice_type: 'S',

			status_code: null,
			//status_code: 'P',
			so_date_from: daysAgo(3),
			so_date_to: today(),
			sales_group_code: null,
			ship_to_code: null,
			bill_to_code: null,
			state: null,
			keyword: null,

			salesGroups: [],
			states: [],
			saleStatusCodes: [],

			invoices: [],
		};
	},
	props: {
		initialKeyword: String,
		initialStatusCode: String,
		initialShipToCode: String,
		initialFromDaysAgo: Number,
		link: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		CustomDatePicker,
		CodeSelect,
		PartnerSelect,
	},
	methods: {
		selectInvoice(invoice) {
			if (this.link) {
				let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
				window.open(routeData.href, 'herp_invoice');
			}
		},
		selectSo(invoice) {
			if (this.link) {
				let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
				window.open(routeData.href, 'herp_so');
			}
		},
		postStatusLoading() {
			//this.status_code = this.initialStatusCode;
			// console.log('post loading', this.status_code);
			// this.$forceUpdate();
			if (this.initialStatusCode || this.initialShipToCode) {
				//if (this.initialShipToCode) {
				//console.log(this.initialShipToCode);
				this.$nextTick(() => {
					this.search();
				});
			}
		},
		setShipTo(partner) {
			this.ship_to_code = partner.code;
			this.search();
		},
		setBillTo(partner) {
			this.bill_to_co = partner.code;
			this.search();
		},
		// async submit() {
		// 	if (this.selectedUserIds.length > 0) {
		// 		//this.$toast.success('Saved successfully');
		// 		this.$emit('set-users', this.selectedUserIds);
		// 		this.close();
		// 	} else {
		// 		this.$toast.error('No user selected');
		// 	}
		// },
		// selectAll() {
		// 	var vm = this;

		// 	vm.selectedUserIds = [];
		// 	if (vm.allSelected) {
		// 		this.users.forEach(function(user) {
		// 			vm.selectedUserIds.push(user.user_id);
		// 		});
		// 	}
		// },
		reset() {
			this.invoice_type = 'S';
			this.status_code = null;
			//this.status_code = this.initialStatusCode;
			this.so_date_from = daysAgo(3);
			this.so_date_to = today();
			this.sales_group_code = null;
			this.ship_to_code = null;
			this.bill_to_code = null;
			this.state = null;
			this.keyword = null;
		},
		search() {
			this.selectInvoices();
		},
		// selectRow(user) {
		// 	if (this.selectedUserIds.includes(user.user_id)) {
		// 		const index = this.selectedUserIds.indexOf(user.user_id);
		// 		if (index > -1) {
		// 			this.selectedUserIds.splice(index, 1);
		// 		}
		// 	} else this.selectedUserIds.push(user.user_id);
		// },
		async selectInvoices() {
			const { data } = await apiSelectInvoiceList({
				paging_yn: 'N',

				invoice_type: this.invoice_type,
				status_code: this.status_code,
				so_date_from: this.so_date_from,
				so_date_to: this.so_date_to,
				sales_group_code: this.sales_group_code,
				ship_to_code: this.ship_to_code,
				bill_to_code: this.bill_to_code,
				state: this.state,
				keyword: this.keyword,
			});

			this.invoices = data.invoiceList;
		},

		selectRow(invoice) {
			//console.log(invoice);
			this.$emit('set-invoice', invoice);
			this.close();
		},

		async index() {
			const { data } = await apiSoIndex();

			this.salesGroups = data.salesGroupList;
			this.states = data.stateList;
		},

		async init() {
			await this.index();
			this.saleStatusCodes = this.$saleStatusCodes;
			this.$nextTick(() => {
				if (this.initialStatusCode) {
					//this.status_code = this.initialStatusCode; //안됨.,.나중에 되게끔 수정할 것
					//console.log('test1', this.initialStatusCode);
					this.status_code = this.initialStatusCode;
				}

				if (this.initialShipToCode) {
					this.ship_to_code = this.initialShipToCode;
					//console.log('test1', this.initialShipToCode);
				}

				//console.log(this.initialStatusCode, this.initialFromDaysAgo);
				if (this.initialFromDaysAgo) this.so_date_from = daysAgo(this.initialFromDaysAgo);
			});
		},

		close() {
			this.$emit('close');
		},
	},
	created() {
		this.init();

		//this.selectPartners();
		//this.item = _.cloneDeep(this.selectedItem);
		// if (this.initialKeyword) {
		// 	this.keyword = this.initialKeyword;
		// 	this.selectSalesOrders();
		// }
	},
	mounted() {
		inputSelectOnClick();

		setTimeout(() => {
			this.$refs.spkeyword.focus();
		}, 10);

		// if (this.initialStatusCode || this.initialShipToCode) {
		// 	//if (this.initialShipToCode) {
		// 	//console.log(this.initialShipToCode);
		// 	this.$nextTick(() => {
		// 		this.search();
		// 	});
		// }
	},
};
</script>

<style></style>
